// SPDX-License-Identifier: MIT
// CP-3 Cloud subscription frontend. DORMANT: the caller only wires these when
// cloudEnabled() (VITE_CLOUD_SUBSCRIPTION_ENABLED) is true. subscribeCloud starts
// the recurring checkout (first payment → mandate) via the `checkout` edge fn in
// ?mode=cloud and redirects to Mollie; cancelCloud cancels the subscription.
import { supabase } from '../auth/supabase';

export const cloudEnabled = (): boolean =>
  import.meta.env.VITE_CLOUD_SUBSCRIPTION_ENABLED === 'true';

export type CloudOutcome =
  | { ok: true }
  | { ok: false; reason: 'need_auth' | 'disabled' | 'error' };

interface CloudResponse { checkout_url?: string; error?: string }

function mapError(error: unknown): 'need_auth' | 'disabled' | 'error' {
  const status = (error as { context?: Response })?.context?.status;
  return status === 401 ? 'need_auth' : status === 503 ? 'disabled' : 'error';
}

export async function subscribeCloud(
  nav: (url: string) => void = (url) => { window.location.href = url; },
): Promise<CloudOutcome> {
  const { data, error } = await supabase.functions.invoke<CloudResponse>('checkout?mode=cloud', { body: {} });
  if (error) return { ok: false, reason: mapError(error) };
  if (!data?.checkout_url) return { ok: false, reason: 'error' };
  nav(data.checkout_url);
  return { ok: true };
}

export async function cancelCloud(): Promise<CloudOutcome> {
  const { error } = await supabase.functions.invoke('checkout?mode=cloud-cancel', { body: {} });
  if (error) return { ok: false, reason: mapError(error) };
  return { ok: true };
}
